import React from "react";
import { useDocumentTitle, useDocumentkeywords, useDocumentdescription, isMobile } from "@/utils";
import Linzhipc from "./pc";
import Linzhimobile from "./mobile";
function LinzhiIntro(props) {
    const {title} = props;
    useDocumentTitle(title);
    useDocumentkeywords('2022林芝桃花VR全景游大赛');
    useDocumentdescription('在圣洁的雪域高原有这么一片如江南般秀美而柔情的宝地，这就是有世界吉尼斯纪录的林芝桃花村，以及享誉全球的林芝桃花节。每年来到此处的游客和摄影师都络绎不绝，留下了无数的传奇故事和精彩照片。随着旅游业的发展和科技的前行，今年我们将举办首届林芝VR全景游摄影大赛，通过360度全方位摄影技术和超高新相机，用最新的科技手段记录令人流连忘返的场景与时刻。VR全景摄影技术不单只是摄影界科技的创新，更是对稀缺旅游资源全方位的数字化备份和保存。在林芝市旅游发展局的倡导下，为旅游插上科技的翅膀，鼓励全社会参与到稀缺旅游资源的保护和宣传当中。');
    return (
        <React.Fragment>
            {isMobile()?<Linzhimobile></Linzhimobile>:<Linzhipc></Linzhipc>}
        </React.Fragment>
    );
}

export default LinzhiIntro;
